module.exports = "<span seedelement><slot></slot>\n  <span class=\"lui-tag__remove-button\">\n    <svg width=\"8\" height=\"8\" viewBox=\"0 0 8 8\">\n      <title>Remove</title>\n      <g fill=\"none\" fill-rule=\"evenodd\">\n        <rect width=\"8\" height=\"8\"/>\n        <polygon fill=\"var(--lui-tag-remove-icon-color)\" fill-opacity=\".9\" points=\"5.41 4 8 6.59 6.58 8 4 5.42 1.42 8 0 6.58 2.59 4 0 1.42 1.41 0 4 2.59 6.59 0 8 1.41\"/>\n      </g>\n    </svg>\n  </span>\n</span>\n"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-tag/theme/lui-tag.html
// module id = 349
// module chunks = 0 1 23